import React, { Component } from "react";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import "react-select/dist/react-select.css";
//import * as loginActions from '../../../actions/loginActions';
//import * as consentActions from '../../../actions/consentActions';


//import PropTypes from "prop-types";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
import rest from "../../../API/api";
import Datetime from "react-datetime";
import ReactDOM from "react-dom";

class Artists_Step1 extends Component {
  constructor(props) {
    super(props);
    this._grabUserInput = this._grabUserInput.bind(this);
    this.isValidated = this.isValidated.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
        Artist: props.getStore().consentArtist,
        Date: props.getStore().consentDate,
        ArtistError: null,

    };
  }

    ComponentDidMount() {

    }
/*
    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }
*/
    handleChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        this.setState({ Artist: ReactDOM.findDOMNode(this.select).value });
    };

    isValidated() {
        const userInput = this._grabUserInput(); // grab user entered vals
        ((this.state.Artist === "") || (this.state.Artist === "Select an artist"))
            ? this.setState({
                ArtistError: (
                    <small className="text-danger">
                        Please pick an artist from the list.
                    </small>
                )
            })
            : this.setState({ ArtistError: null });
        var artist = ((this.state.Artist !== "") && (this.state.Artist !== "Select an artist"));


        var valid = (artist);
        if(valid)
            this.props.updateStore({
                ...userInput,
                savedConsent: false // use this to notify step4 that some changes took place and prompt the user to save again
            });
        return valid;
    }


  _grabUserInput() {

    return {
        consentDate: document.getElementById('TodayDate').value,
        consentArtist: ReactDOM.findDOMNode(this.select).value,
    };
  }

    handleRadio = event => {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        });
    };

  render() {
    return (

      <div className="wizard-step">
          <Row>
              <Col md={5} mdOffset={1}>
                  <FormGroup>
                      <img
                          className="img-responsive"
                          src={this.props.consentSubmission.TitleImage}
                      />
                  </FormGroup>
              </Col>
          </Row>
          <Row>
              <Col md={5} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>Today's Date is: </ControlLabel>
                      <FormControl
                          id="TodayDate"
                          type="text"
                          name="today_date"
                          disabled={true}
                          value={new Date()}
                      />
                  </FormGroup>
              </Col>
          </Row>
          <Row>
              <Col md={5} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>Which artists are you working with today? <span className="text-danger">*</span> </ControlLabel>
                      <FormControl componentClass="select"
                                   placeholder="Select an artist"
                                   ref={select => { this.select = select }}
                                   onChange={this.handleChange}
                                   value={this.state.Artist}
                      >
                          <option value="Select an artist">Select an artist</option>
                          {
                              this.props.consentSubmission.IncludedArtists.map((e, key) => {
                              return <option key={key} value={e.Name}>{e.Name}</option>;
                          }) }
                      </FormControl>
                      {this.state.ArtistError}
                  </FormGroup>
              </Col>
          </Row>
      </div>
    );
  }
}
/*
function mapStateToProps(state, ownProps) {
    return {
        userLoggedIn: state.userLoggedIn,
        consent: state.consent,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        consentActions: bindActionCreators(consentActions, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Artists_Step1);
*/
export default Artists_Step1;



// WEBPACK FOOTER //
// ./src/views/Forms/DisplayConsentFormWizard/Artists_Step1.jsx